import { render, staticRenderFns } from "./TradesHistory.vue?vue&type=template&id=034ec160&scoped=true"
import script from "./TradesHistory.vue?vue&type=script&lang=js"
export * from "./TradesHistory.vue?vue&type=script&lang=js"
import style0 from "./TradesHistory.vue?vue&type=style&index=0&id=034ec160&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "034ec160",
  null
  
)

export default component.exports